export default __webpack_public_path__ + "static/notifications-presentation-kz-55fc4808b24704b27316d192050b5fd6.png";